export const isValidRecord = (record: unknown): record is Record<string, unknown> => typeof record === 'object' && record !== null;

// import { useAuthActions } from '@/store-composables';

export async function usePubsub() {
	const { useAuthActions } = await (() => import('@/store-composables/auth'))(); // Lazy load to avoid circular dependency
	const { subscribeToInvalidToken, subscribeToRefreshToken, unsubscribeToInvalidToken, unsubscribeToRefreshToken } = useAuthActions();
	return { subscribeToRefreshToken, unsubscribeToRefreshToken, subscribeToInvalidToken, unsubscribeToInvalidToken };
}
